import { render, staticRenderFns } from "./avoiding-distractions-a45.vue?vue&type=template&id=f1e06636&"
import script from "./avoiding-distractions-a45.vue?vue&type=script&lang=js&"
export * from "./avoiding-distractions-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports